<div
  *transloco="let t; prefix: 'saved-view-create-component'"
  class="xi-modal__container saved-view-create__container"
>
  <h2 class="xi-modal__title">
    {{ title() || t('title') }}
  </h2>

  <div class="xi-modal__content">
    <form autocomplete="off">
      <div class="xi-input-field-wrapper">
        <xi-input-field
          placeholder="{{ t('placeholder') }}"
          name="savedViewName"
          [(ngModel)]="name"
          (onChange)="onNameChange()"
          appAutoFocus="xiInput"
          [label]="t('description')"
          [status]="isDuplicate ? { state: 'error', text: t('duplicate-error') } : null"
        ></xi-input-field>
      </div>
    </form>
  </div>

  <div class="xi-modal__actions">
    <xi-default-button text="{{ t('cancel') }}" fill="text" (onClick)="onCancel()">
    </xi-default-button>
    <xi-default-button text="{{ t('save') }}" [disabled]="!canSave()" (onClick)="onSave()">
    </xi-default-button>
  </div>
</div>
